import { render, staticRenderFns } from "./Ewa.vue?vue&type=template&id=c415e646"
import script from "./Ewa.vue?vue&type=script&lang=js"
export * from "./Ewa.vue?vue&type=script&lang=js"
import style0 from "./Ewa.vue?vue&type=style&index=0&id=c415e646&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports